<div class="wrapper" #trigger="cdkOverlayOrigin" cdkOverlayOrigin>
  <app-deposit-button />
  <app-wallet-row [type]="type()" (onoverlay)="toggle()" [isOpen]="isOpen()" />
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  (overlayOutsideClick)="toggle()"
  [cdkConnectedOverlayPositions]="positions"
>
  <div class="overlay-wrapper">
    <div class="component" [ngClass]="{ animation: animation() }">
      <app-wallet-select (onselect)="toggle()" />
    </div>
  </div>
</ng-template>
